export default __webpack_public_path__ + "f03167527bf8b439ae2d5d1076dddfb9.svg";